// Disable Scroll

let isScrollDisabled = false;
let topScroll = 0;
const disabledScrollClass = 'scroll-disabled';

function disableScroll() {
  if (!isScrollDisabled) {
    topScroll = jQuery(window).scrollTop();
    jQuery('body').css('top', `${-topScroll}px`).addClass(disabledScrollClass);
    isScrollDisabled = true;
  }
}

function enableScroll() {
  if (isScrollDisabled) {
    jQuery('body').removeAttr('style').removeClass(disabledScrollClass);
    jQuery(window).scrollTop(topScroll);
    isScrollDisabled = false;
  }
}